import produce from 'immer';
import { FETCH, FETCH_ERROR, FETCH_SUCCESS, RESET_QUERY } from './action-types';

const initialState = {
  isLoading: false,
  query: '',
  results: {
    vod: null,
    channels: null,
    programs: null,
  },
  isError: false,
};

export type SearchStateType = typeof initialState;

export default produce((draft: SearchStateType, action) => {
  switch (action.type) {
    case FETCH:
      draft.isLoading = true;
      draft.query = action.payload;
      break;
    case FETCH_SUCCESS:
      draft.isLoading = false;
      draft.query = action.results;
      draft.results = action.payload;
      break;
    case FETCH_ERROR:
      draft.isLoading = false;
      draft.isError = true;
      break;
    case RESET_QUERY:
      draft.isLoading = false;
      draft.results = {
        vod: null,
        channels: null,
        programs: null,
      };
      break;
    default:
    // nothing
  }
}, initialState);
